// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__gYBzn","tooltip__label":"styles_tooltip__label__rEuoh","tooltip__value":"styles_tooltip__value__tsRoy"};